import { IonIcon } from "@ionic/react";
import { cx } from "@/lib/style/cva.config";

export function TitleIcon(props: React.ComponentProps<typeof IonIcon>) {
  return (
    <IonIcon
      {...props}
      className={cx("size-6 rounded-xl bg-surface-neutral p-2 text-txt-primary", props.className)}
    />
  );
}
